import { UserModel } from '@/store/types/user';

export interface Position {
  id: number,
  title: string,
  user_id?: number,
  user?: UserModel,
  user_name?:string,
  user_last_name?:string,
  user_phone?:string,
  user_photo?:string,
}

export class PositionModel implements Position {
  id: number;
  title: string;
  user?: UserModel;
  user_id?: number;

  constructor (data: Position) {
    this.id = data.id;
    this.title = data.title;
    this.user = data.user ? new UserModel(data.user) : undefined;
    this.user_id = data.user_id;
    if (!this.user && data.user_name) {
      this.user = new UserModel({
        id: data.user_id,
        name: data.user_name,
        last_name: data.user_last_name,
        phone: data.user_phone,
        photo: data.user_photo
      });
    }
  }
}
